<template>
  <v-row dense align="center" justify="end">
    <v-col sm="4">
      <v-switch
        v-model="on"
        label="Lookback"
        class="my-0 ml-2"
        @change="onLookbackSwitch"
        :disabled="disabled"
      ></v-switch>
    </v-col>
    <v-col sm="5" class="px-0">
      <v-select
        :disabled="!on"
        :items="items"
        label="Shift Year(s)"
        :outlined="outlinedInputs"
        class="my-0"
        v-model="year"
        @change="onChange"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "rates-loockback",

  props: {
    value: {
      type: Number,
      default: () => 0,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      on: this.value > 0,
      items: [1, 2, 3, 4, 5],
      year: this.value ? this.value : 1,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onLookbackSwitch() {
      if (this.on) {
        this.year = 1;
        this.$emit("input", this.year);
      } else {
        this.$emit("input", 0);
      }
    },
    onChange() {
      this.$emit("input", this.year);
    },
  },

  watch: {
    value(newVal) {
      this.year = newVal || 1;
      this.on = newVal > 0;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/RatesLookback.vue